import React, { useEffect, useState } from "react";
import SignUpComponent from "./signUpComponent";
import { errorCode, failureMessageConstant, path } from "../../constants";
import history from "../../managers/history";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader, updateUser } from "../../slices/userSlice";
import Utils from "../../utility";
import UserService from "../../services/businessUser";
import { Auth0Service } from "../../services";
const SignUp = () => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  let urlEmail = params.get("email") || "";
  urlEmail = urlEmail ? urlEmail.replace(/\s/g, "+") : "";
  const urlName = params.get("name") || "";
  const urlId = params.get("id") || "";

  useEffect(() => {
    if (location?.hash?.includes(errorCode.USER_NOT_VERIFIED)) {
      history.push(path.EMAIL_VERIFICATION);
    } else {
      const searchParams = new URLSearchParams(location.hash.substring(1));
      const errorDescription = searchParams.get("error_description");
      if (
        errorDescription &&
        (errorDescription == failureMessageConstant.INVALID_LOGIN_TICKET ||
          errorDescription ==
            failureMessageConstant.UNABLE_TO_CONFIGURE_VERIFICATION_PAGE)
      ) {
        Utils.failureToastMessage(
          failureMessageConstant.ENABLE_THIRD_PARTY_COOKIES_DESC,
          5
        );
      } else {
        Utils.failureToastMessage(errorDescription);
      }
    }
  }, []);

  const dispatch = useDispatch();
  const [states, setStates] = useState({
    loader: false
  });
  const updateState = (name, value) => {
    setStates((prevState) => ({ ...prevState, [name]: value }));
  };
  const signIn = async (data) => {
    try {
      const { email, password } = data;
      // Sign in using auth0Service
      await new Auth0Service().signIn({ email, password });
    } catch (err) {
      console.error(err);
    }
  };
  // FUNCTION TO SIGNUP
  const signUp = async (data) => {
    try {
      const response = await new Auth0Service().signUp({
        name: data.name,
        email: data?.email.toLowerCase(),
        password: data?.password
      });
      if (response) {
        await signIn(data);
      }
    } catch {
      Utils.failureToastMessage(failureMessageConstant.SOMETHING_WENT_WRONG);
    } finally {
      updateState("isLoading", { type: "login", value: false });
      dispatch(hideLoader());
    }
  };
  // FUNCTION TO CHECK BUSINESS EXISTS OR NOT
  const checkBusinessAlreadyExistsOrNot = async (data) => {
    const { email, password } = data;
    const userEmail = email.toLowerCase();
    const encryptedPassword = Utils.encryptPassword(password);
    dispatch(updateUser({ email: userEmail, password: encryptedPassword }));
    try {
      dispatch(showLoader());
      updateState("isLoading", { type: "login", value: true });
      const [error, businessResponse] = await Utils.parseResponse(
        new UserService().checkBusinessExists({ email: userEmail })
      );

      if (
        businessResponse == null ||
        (businessResponse.email == userEmail && businessResponse._id == urlId)
      ) {
        await signUp(data);
      } else if (businessResponse != null && businessResponse._id) {
        Utils.failureToastMessage(failureMessageConstant.PLEASE_SIGN_IN);
        setTimeout(() => {
          history.push("/");
        }, 3000);
        return;
      } else {
        console.error(error);
        Utils.failureToastMessage(failureMessageConstant.SOMETHING_WENT_WRONG);
      }
    } catch (error) {
      console.error(error);
      return;
    } finally {
      updateState("isLoading", { type: "login", value: false });
      dispatch(hideLoader());
    }
  };

  return (
    <SignUpComponent
      states={states}
      urlEmail={urlEmail}
      urlName={urlName}
      functionObj={{ checkBusinessAlreadyExistsOrNot, signUp }}
    />
  );
};

export default SignUp;
